import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from '@material-ui/core/Button'
import Snackbar from '@material-ui/core/Snackbar'
import Fade from '@material-ui/core/Fade'

import * as configActions from '../../actions/Config'

class FadeSnackbar extends React.Component {
  render() {
    const { config } = this.props

    return (
      <Snackbar
        open={config.snackbar.show}
        onClose={() => this.props.hideSnackbar()}
        TransitionComponent={Fade}
        ContentProps={{
          'aria-describedby': 'message-id'
        }}
        message={<span id={'message-id'}>{config.snackbar.message}</span>}
      />
    )
  }
}

function mapStateToProps({ config }) {
  return { config }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(FadeSnackbar)



// WEBPACK FOOTER //
// ./src/components/containers/Snackbar/index.js